import { render } from "./UiDropdown.vue?vue&type=template&id=5eea8698&lang=pug"
import script from "./UiDropdown.vue?vue&type=script&lang=js"
export * from "./UiDropdown.vue?vue&type=script&lang=js"

import "./UiDropdown.vue?vue&type=style&index=0&id=5eea8698&lang=sass"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__